import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import useAxios from "services/useAxios.tsx";
import CustomButton from "components/kits/custom-button/CustomButton.tsx";

export default function LogInNumber({ ChangeModal, login, SetNumber, number }) {
  const { loading: loadingGetCode, execute: getLoginCodeApi } = useAxios("api/getlogincode");
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
  useEffect(() => {
    (() => {
      "use strict";

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.querySelectorAll(".needs-validation");
      Array.prototype.slice.call(forms).forEach((form) => {
        form.addEventListener(
          "submit",
          (event) => {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    })();
  }, []);

  let SendNumber = (e) => {
    e.preventDefault();
    const pattern = /^09\d{9}$/;

    if (!pattern.test(number)) {
      setIsPhoneNumberValid(false);
      return "";
    }
    setIsPhoneNumberValid(true);

    // formData.append("step", "1");

    // sendRequest("getlogincode", { mobile: number })
    getLoginCodeApi({ mobile: number })
      // .then(({ data }) => {
      .then((data) => {
        if (data.status == 1) {
          ChangeModal(1);
          login(data.data.hashcode);
        } else if (data.status == 0) {
          Swal.fire({
            title: "خطا!",
            text: "لطفا دوباره امتحان کنید",
            type: "error",
            confirmButtonText: "باشه",
          });
        } else if (data.status == -1) {
          Swal.fire({
            title: "خطا!",
            text: "شما مجاز نیستید",
            type: "error",
            confirmButtonText: "باشه",
          });
        }
      })
      .catch((error) => {
        ChangeModal(1);
        login("gg");
        Swal.fire({
          title: "خطا",
          text: "لطفا دوباره امتحان کنید",
          type: "error",
          confirmButtonText: "باشه",
        });
      });
  };

  return (
    <form className="needs-validation" noValidate onSubmit={SendNumber}>
      <div className="modal-body text-center">
        {/* <h5>ورود یا ثبت نام در فروشگاه  </h5> */}{" "}
        {/* shFazeli 1402/04/31 end */}
        <label htmlFor="number" className="mb-4 my-3 text-muted">
          شماره موبایل خود را وارد کنید
          {/* برای ورود به فروشگاه شماره همراه خود را وارد کنید */}{" "}
          {/* shFazeli 1402/04/31 end */}
        </label>
        <input
          onChange={SetNumber}
          value={number}
          type="tel"
          style={{
            height: "50px",
            borderRadius: "15px",
            direction: "ltr",
            fontFamily: "inherit", //shFazeli 1402/04/31 end
            textAlign: "center",
          }}
          id="number"
          placeholder="09*********"
          className="form-control w-75 mx-auto"
          required
        />
        {!isPhoneNumberValid && (
          <div
            style={{
              color: "#7C3AED",
              fontSize: "12px",
              textAlign: "right",
              margin: "5px 60px 0px 0px",
            }}
          >
            شماره وارد شده اشتباه است.
          </div>
        )}
        {/* <input onChange={SetNumber} value={number} placeholder="" id="pass" class="form-control form-phone" type="tel" pattern="[0-9]{10}" required name="mobile" /> */}
        <div
          className="invalid-feedback text-start"
          style={{ marginRight: "63px" }}
        >
          لطفا شماره موبایل خودرا وارد کنید
        </div>

        {/* hosseini 1402/05/21 */}
        <CustomButton
          state={loadingGetCode ? "loading" : "default"}
          onClick={SendNumber}
          className="btn my-3 w-75 pd-y-8 he-50 text-white mx-auto"
          style={{ backgroundColor: "#7C3AED" }}
        >
          ادامه
        </CustomButton>
      </div>
    </form>
  );
}
